export default "__VITE_ASSET__y8bfb9HV__"